/**
 * Per-participant colour palette used by Avatar / AvatarStack /
 * AttributionChip / ClaimPill across the group-ordering surfaces.
 *
 * Each participant carries a `colorIndex` (0-7) stamped server-side at join
 * time. We map that into a triple of compatible hues so chips and pills
 * stay readable on both white and tinted backgrounds:
 *   - `strong`  — primary fill (avatar background, claim pill bg)
 *   - `fg`      — text/icon colour on `strong`-tinted surfaces
 *   - `soft`    — muted background for chips, banners, claim previews
 */

export interface ParticipantColor {
  strong: string;
  fg: string;
  soft: string;
}

export const PALETTE: readonly ParticipantColor[] = [
  { strong: "#0BAA57", fg: "#067A3F", soft: "#E2F8EE" }, // 0 — host green
  { strong: "#3B82F6", fg: "#1D4ED8", soft: "#DBEAFE" }, // 1 — blue
  { strong: "#F59E0B", fg: "#B45309", soft: "#FEF3C7" }, // 2 — amber
  { strong: "#EC4899", fg: "#BE185D", soft: "#FCE7F3" }, // 3 — pink
  { strong: "#8B5CF6", fg: "#6D28D9", soft: "#EDE9FE" }, // 4 — purple
  { strong: "#06B6D4", fg: "#0E7490", soft: "#CFFAFE" }, // 5 — cyan
  { strong: "#EF4444", fg: "#B91C1C", soft: "#FEE2E2" }, // 6 — red
  { strong: "#84CC16", fg: "#4D7C0F", soft: "#ECFCCB" }, // 7 — lime
];

export function colorFor(index: number): ParticipantColor {
  if (!Number.isFinite(index) || index < 0) return PALETTE[0];
  return PALETTE[index % PALETTE.length];
}
